import { HorizontalSpaceBetween, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import HealthCharts from 'components/HealthCharts';
import BodyText from 'components/text/BodyText';
import CaptionText from 'components/text/CaptionText';
import CardTitleText from 'components/text/CardTitleText';

import useTranslation from './hooks/useTranslation';

import Badges from './components/Badges';
import DroneActivityLink from './components/DroneActivityLink';
import DroneCardDetails from './components/DroneCardDetails';
import LastSynced from './components/LastSynced';
import { TEST_ID } from './constants';
import type { BadgeType, FunctionComponent, Props, Readiness } from './types';

import styles from './styles.module.scss';

const readinessBadgeMap: Record<Readiness, BadgeType> = {
    AIRWORTHY: 'READY',
    GROUNDED: 'GROUNDED',
    HOLD: 'HOLD'
};

const DroneCard: FunctionComponent<Props> = ({
    className = '',
    droneId,
    faaRegistrationNumber,
    firmware,
    lastSyncedAt,
    metrics,
    name,
    onClick,
    readiness,
    serial,
    testId = TEST_ID,
    usage,
    warrantyEnd
}) => {
    const { NOTE_GROUNDED, NOTE_HOLD } = useTranslation();

    const noteMap: Record<Readiness, string> = {
        AIRWORTHY: '',
        GROUNDED: NOTE_GROUNDED,
        HOLD: NOTE_HOLD
    };

    const note = noteMap[readiness];

    return (
        <Wrapper className={`${className} ${styles.droneCard}`} onClick={onClick} testId={testId}>
            <HorizontalSpaceBetween className={styles.header}>
                <VerticalContainer className={styles.verticalContainer}>
                    <CardTitleText text={name} />

                    <BodyText className={styles.serial} text={serial} />

                    {note && <CaptionText className={styles.note} text={note} />}
                </VerticalContainer>

                <Badges items={[readinessBadgeMap[readiness]]} />
            </HorizontalSpaceBetween>

            {lastSyncedAt && <LastSynced syncedAt={lastSyncedAt} />}

            <HealthCharts className={styles.healthCharts} items={metrics} />

            <DroneCardDetails
                className={styles.details}
                faaRegistrationNumber={faaRegistrationNumber}
                firmware={firmware}
                serial={serial}
                usage={usage}
                warrantyEnd={warrantyEnd}
            />

            <DroneActivityLink className={styles.activityLink} droneId={droneId} />
        </Wrapper>
    );
};

export default DroneCard;
